<style scoped lang="scss" type="text/scss">
    .two-cols-row {
        /* element-ui el-item 高度为 2.5rem margin-bottom 为 22px */
        height: calc(2.5rem + 22px);
    }
</style>

<template>
    <div class="two-cols-row">
        <el-col :span="12">
            <slot name="left" class="full-width"></slot>
        </el-col>
        <el-col :span="12">
            <slot name="right" class="full-width"></slot>
        </el-col>
    </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {};
        }
    };
</script>
